import error from "../../../../functions/error";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {onDateTimeInput, onPhoneInput} from "../../../../functions/mask";
import urls from "../../../../urls";
import {useDispatch, useSelector} from "react-redux";
import {setUserDataItem} from "../../../../store/userDataSlice";
import ContragentRequest from "../../../../api/cabinet/Contragent";
import TaskRequest from "../../../../api/cabinet/Task";
import CabinetRequest from "../../../../api/cabinet/Cabinet";
import FormItem from "../../../UI/fields/FormItem";
import {SmartCaptcha} from "@yandex/smart-captcha";
import {fileFieldsForSVO} from "./consts";
import {FileRequest} from "../../../../api/cabinet/File";
import {Button} from "indicator-ui";

export const useBuyLandForm = ({initialData, activeLandploat}) => {
    const SVO_KEY = 'svo'
    const RESIDENTIAL_PLOTS_KEY = 'residential_plots'
    const contragentRequest = new ContragentRequest()
    const taskRequest = new TaskRequest()
    const fileRequest = new FileRequest()
    const cabinet = new CabinetRequest()

    const dispatch = useDispatch()
    const addUserData = (name, value) => dispatch(setUserDataItem([name, value]))
    const userData = useSelector(state => state.user_data.userData)

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const LAND_TYPE = useMemo(() => params.get('type')?.toLowerCase(), [params])

    const [dataContragentToSend, setDataContragentToSend] = useState({}) // данные контрагента для отправки (сюда кладутся только измененные поля)
    const [oldDataContragent, setOldDataContragent] = useState({}) // старые данные контрагента, чтобы отследить былили изменения в данных
    const [formSuccess, setFormSuccess] = useState(false) // форма успешно отправлена, скрыть формы и показать успешное сообщение
    const [formError, setFormError] = useState('')
    const [formLoader, setFormLoader] = useState(false) // любая форма отправлена с ошибкой, показать сообщение об ошибке

    const [sendCode, setSendCode] = useState(false) // true показывает форму подтверждения по коду (в сценариях логина и регистрации)

    const [errors, setErrors] = useState({}) // ошибки всех полей

    const [token, setToken] = useState(''); // capcha

    const fieldsContragent = [
        {
            name: 'fio',
            type: 'text',
            label: 'ФИО',
            required: true,
            read_only: !!userData.contragent
        },
        {
            name: 'birth_date',
            type: 'text',
            label: 'Дата рождения',
            placeholder: 'ДД.ММ.ГГГГ',
            mask: onDateTimeInput,
            required: true,
        },
        {
            name: 'email',
            type: 'email',
            label: 'Электронная почта',
            required: true,
        },
        {
            name: 'phone',
            type: 'text',
            label: 'Телефон',
            placeholder: '+7',
            mask: onPhoneInput,
            required: true,
            read_only: !!userData.contragent
        },
    ] // схема полей контрагента
    const [dataContragent, setDataContragent] = useState({
        status: "Физическое лицо"
    })

    const [data, setData] = useState(initialData)
    const [fields, setFields] = useState([
        {
            id: 'preferencial',
            name: 'preferencial',
            type: LAND_TYPE === RESIDENTIAL_PLOTS_KEY ? 'checkbox' : 'hidden',
            label: '',
            choices: []
        },
        ...LAND_TYPE === SVO_KEY ? [
            {
                id: 'passportCopy',
                name: 'passportCopy',
                type: 'file',
                label: 'Копия паспорта',
                required: true
            }
        ] : [],
        {
            id: 'department',
            name: 'department',
            type: 'hidden'
        },
        {
            id: 'category',
            name: 'category',
            type: 'hidden'
        },
        {
            id: 'contragent',
            name: 'contragent',
            type: 'hidden',
        }
    ]) // дополнительные поля формы кроме контрагента
    const accessCheckbox = {
        id: 'obrabotka',
        name: 'obrabotka',
        type: 'boolean',
        label: <>Даю согласие на <a href={urls.soglashenie.path} target='_blank'>обработку персональных
            данных</a></>,
        required: true,
    } // схема чекбокса на согласие

    const fileFields = fileFieldsForSVO // схема полей дополнительных файлов
    const [files, setFiles] = useState({}) // данные файлов для отправки
    const savedFiles = useRef({ // отметка какие файлы загружены на сервер коллектива, их желательно больше не грузить
        passport: false,
        doc: false,
    })
    const [selectedFile, setSelectedFile] = useState('') // выбранный файл для селекта дополнительных файлов
    // схема поля селекта дополнительного файла
    const selectFile = {
        label: 'Копия документа',
        type: 'select',
        name: 'selectFile',
        placeholder: 'Выберите Ваш документ',
        required: true,
        choices: [
            {value: fileFieldsForSVO['1'].name, label: fileFieldsForSVO['1'].labelForOption},
            {value: fileFieldsForSVO['2'].name, label: fileFieldsForSVO['2'].labelForOption},
            {value: fileFieldsForSVO['3'].name, label: fileFieldsForSVO['3'].labelForOption},
            {value: fileFieldsForSVO['4'].name, label: fileFieldsForSVO['4'].labelForOption},
            {value: fileFieldsForSVO['5'].name, label: fileFieldsForSVO['5'].labelForOption},
            {value: fileFieldsForSVO['6'].name, label: fileFieldsForSVO['6'].labelForOption},
        ]
    }

    const [btnActive, setBtnActive] = useState(false)

    const checkButtonActive = () => ((Object.keys(dataContragent).length >= fieldsContragent.length)
            && (Object.keys(data).length >= fields.length)
            && token
            && data.obrabotka
            && (LAND_TYPE === SVO_KEY ? Object.entries(files).length === 2 : true))


    useEffect(() => {
        const newData = {...data}
        newData.landplot = activeLandploat.id
        newData.type = activeLandploat.type
        setData({...newData})
    }, [activeLandploat])

    useEffect(() => {
        if (userData.contragent) {
            // предзаполнение полей контрагента
            contragentRequest.getById(userData.contragent).then(response => {
                if (response.success) {
                    for (let key in response.data.data) {
                        if (key)
                            dataContragent[key] = response.data.data[key]
                        setDataContragent({...dataContragent})
                        setOldDataContragent({...dataContragent})
                    }
                } else {
                    if (response.data.response.status === 500) {
                        setFormError('Ошибка сервера, попробуйте зайти позже')
                    } else {
                        setFormError(response.message)
                    }
                }
            })
        } else {
            console.log('не залогинен')
        }
        if (LAND_TYPE !== 'COMMERCIAL_PLOTS') {
            taskRequest.preferencial()
                .then(response => {
                    if (response.success) {
                        fields.filter(item => item.name === 'preferencial')[0].choices = response.data.data
                        setFields([...fields])
                    } else {
                        setFormError(error(response))
                    }
                })
        }
    }, [])

    useEffect(() => {
        setBtnActive(checkButtonActive())
    }, [token])

    const setContragentValue = (name, value) => {
        dataContragent[name] = value
        value ?? delete dataContragent[name]
        if (value === '')
            delete dataContragent[name]

        setDataContragent({...dataContragent})

        if (Object.keys(dataContragent).length >= fieldsContragent.length) {
            if (data.obrabotka)
                setBtnActive(true)
            else
                setBtnActive(false)
        } else {
            setBtnActive(false)
        }
    }

    const setValue = (name, value, type = '') => {
        if (type === 'file') {
            files[name] = value
            value ?? value?.length === 0 ?? delete data[name]
            setFiles({...files})
        } else {
            data[name] = value
            value ?? delete data[name]
            if (value === '')
                delete data[name]

            setData({...data})
        }

        setBtnActive(checkButtonActive())
    }

    const setError = (name, error) => {
        if (error) {
            errors[name] = error
        } else {
            try {
                delete errors[name]
            } catch {
            }
        }
        setErrors({...errors})
    }

    const taskCreate = async (contragent = null) => {
        if (contragent) {
            data.contragent = contragent
            setData(data)
        }

        if (LAND_TYPE === SVO_KEY) { // если участок для СВО отправить документы
            for (const key of Object.keys(files)) {
                const name = key === 'passportCopy' ? 'passport' : 'doc'
                const form = new FormData()
                form.append('file', files[key]?.[0])
                form.append('captcha_token', token)
                const response = await fileRequest.upload(form)
                if (response.success) {
                    savedFiles.current[name] = response.data
                } else {
                    console.log(response.data)
                    setFormError('Ошибка загрузки файла')
                }
            }
            if (savedFiles.current['passport'] && savedFiles.current['doc']) {
                data.documents = [{file: savedFiles.current['passport']}, {file: savedFiles.current['doc']}]
                setData(data)
            } else {
                console.log('Незаполнены файлы')
                console.log('savedFiles', savedFiles)
            }
        }
        taskRequest.create({task: data})
            .then(response => {
                if (response.success) {
                    setFormSuccess(true)
                } else {
                    const status = response.data?.response?.data?.data?.message || response.data?.response?.data?.data?.landplot[0]

                    if (status) {
                        setFormError(status)
                    } else {
                        setFormError(error(response))
                    }
                }
                setFormLoader(false)
            })
    }

    // экспорнируется для использования в сценарии регистрации
    // => вызывает createTask
    const createContragent = () => {
        contragentRequest.create({contragent: dataContragent})
            .then(response => {
                if (response.success) {
                    if (response.data.data.id) {
                        addUserData('contragent', response.data.data.id)
                        taskCreate(response.data.data.id)
                    } else {
                        setFormError('Ошибка: в ответе нет контрагента ')
                    }
                } else {
                    setFormError(error(response))
                }
                setFormLoader(false)
            })
    }

    // апдейт данных контрагента, экспорнируется для использования в сценарии регистрации
    // => вызывает createTask
    const updateContragent = () => {
        contragentRequest.update({contragent: {...dataContragentToSend, id: userData.contragent}})
            .then(data => {
                if (data.success) {
                    if (data.data.data.id) {
                        addUserData('contragent', data.data.data.id)
                        taskCreate(data.data.data.id)
                    } else {
                        setFormError('Ошибка: в ответе нет контрагента ')
                    }
                } else {
                    setFormLoader(false)
                    setFormError(error(data))
                }
                setFormLoader(false)
            })
    }

    const sendData = () => {
        setFormLoader(true)
        if (dataContragent.phone) {
            addUserData('user_login', dataContragent.phone)
        }
        // если юзер залогинен
        if (userData.contragent) {
            let contragent_changed = false
            for (const key in dataContragent) {
                if (dataContragent[key] !== oldDataContragent[key]) {
                    dataContragentToSend[key] = dataContragent[key]
                    contragent_changed = true
                }
            }

            setDataContragentToSend({...dataContragentToSend})

            if (contragent_changed) { // поля контрагента изменены отправляем обновление
                updateContragent()
            } else {
                taskCreate() // просто создаем задачу
            }
        }
        // если юзер не залогинен отправляем на логин (внутри происходит логин/регистрация)
        else {
            cabinet.sendCode({phone: dataContragent.phone, captcha_token: token})
                .then(response => {
                    if (response.success) {
                        setFormLoader(false)
                        setSendCode(true)
                    } else {
                        setFormLoader(false)
                        setFormError(error(response))
                    }
                })
        }
    }

    const render = <>
        {fieldsContragent.map(item => (
            <div>
                <FormItem
                    key={`userData_${item.name}`}
                    field={item}
                    mask={item.mask}
                    value={dataContragent[item.name] || ''}
                    setValue={setContragentValue}
                    error={errors[item.name] || false}
                    setError={setError}/>
            </div>
        ))}

        {fields.map(item => (
            <div>
                <FormItem
                    key={`data_${item.name}`}
                    field={item}
                    mask={item.mask}
                    value={item.type === 'file' ? files[item.name] || [] : data[item.name] || ''}
                    setValue={(name, value) => setValue(name, value, item.type)}
                    error={errors[item.name] || false}
                    setError={setError}/>
            </div>
        ))}
        <div className={'mt-16'}><FormItem field={accessCheckbox}
                                           value={data['obrabotka'] || ''}
                                           setValue={setValue}
                                           error={errors['obrabotka'] || false}
                                           setError={setError}
        /></div>
        {LAND_TYPE === SVO_KEY && <>
            <h2 className={'form-subtitle'}>Копия одного из документов</h2>
            <div><FormItem field={selectFile}
                           value={selectedFile}
                           setValue={(_, value) => setSelectedFile(value)}
                           error={false}
                           setError={() => {
                           }}
            /></div>
            {fileFields[selectedFile] && <div className={'mb-16'}><FormItem field={fileFields[selectedFile]}
                                                                            value={files[selectedFile] || []}
                                                                            setValue={(name, value) => setValue(name, value, 'file')}
                                                                            error={errors[selectedFile] || false}
                                                                            setError={() => {
                                                                            }}
            /></div>}
        </>}
        <SmartCaptcha
            sitekey={process.env.REACT_APP_CAPTCHA_CLIENT_KEY}
            onTokenExpired={(e) => {
                setToken('')
            }}
            onSuccess={setToken}
            language={'ru'}/>
    </>

    return {
        render,
        sendData,
        updateContragent,
        createContragent,
        taskCreate,
        formError,
        formLoader,
        formSuccess,
        sendCode,
        btnActive,
    }
}